<template>
  <div class="st-error" :role="role">
    <st-icon
      name="warning-triangle"
      size="small"
      :alt="alt"
      :icon-props="{ color: 'var(--danger-color-primary)' }"
    />
    <div class="st-error__text">
      <slot>
        {{ errorMessage }}
      </slot>
      <strong v-if="errorCode" class="st-error__text--highlighted">
        {{ errorCode }}
      </strong>
    </div>
  </div>
</template>

<script setup>
import StIcon from "../icon/Icon.vue";
import { computed } from "vue";

const props = defineProps({
  errorMessage: {
    type: String,
    default: "Något gick snett, var god försök igen senare.",
  },
  errorCode: {
    type: String,
    default: "",
  },
  alt: {
    type: String,
    default: "",
  },
  setRoleAlert: {
    type: Boolean,
    default: true,
  },
});

const role = computed(() => (props.setRoleAlert ? "alert" : null));
</script>
<style lang="scss" scoped>
@import "../../scss/main.scss";
.st-error {
  display: flex;
  font-family: var(--font-primary);
  border-radius: rem-calc(6);
  background-color: var(--danger-color-secondary);
  border: rem-calc(2) solid var(--danger-color-primary);
  padding: rem-calc(12);
  font-size: rem-calc(16);
  overflow-wrap: anywhere;
  color: var(--text-color-primary);
  line-height: rem-calc(21);

  & > :first-child {
    margin-right: rem-calc(12);
  }

  &__text {
    display: flex;
    flex-direction: column;

    &--highlighted {
      line-height: rem-calc(24);
      font-weight: 600;
    }
  }
}
</style>
